import React from 'react'

const ManageTasks = () => {
  return (
    <div>ManageTasks</div>
  )
}

export default ManageTasks